const defaultState = {
  location: {},
  error: null,
  saving: false,
  saved: false
};

const addEditLocationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_EDIT_LOCATION_SAVE_PENDING': {
      return {
        ...state, saving: true, error: null
      };
    }
    case 'ADD_EDIT_LOCATION_SAVE_FULFILLED': {
      return {
        ...state, saving: false, error: null, saved: true, newLocation: action.payload
      };
    }
    case 'ADD_EDIT_LOCATION_SAVE_REJECTED': {
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default addEditLocationReducer;


// WEBPACK FOOTER //
// ./src/reducers/addEditLocation.js